

module.exports = __webpack_require__.stylable.create(
    "thumbnail1780107866",
    {"classes":{"root":"thumbnail1780107866__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    /*! ../node_modules/@wix/search-box-v2/dist/src/components/Thumbnail/Thumbnail.st.css */ 1320,
    null
);
